import { Skeleton, Space } from "antd";
import { useEffect, useState } from "react";
import { useAuth } from "src/core/hooks/useAuth";
import { OverheadDataTable } from "src/modules/PriceConfiguratorManager/components/DataSectionManager/sections/Overhead/components/OverheadDataTable";

export const Overhead: React.FC = () => {
  const { success, authLoaded } = useAuth();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      if (authLoaded && success) {
        setLoading(false);
      }
    })();
  }, [authLoaded, success]);

  return (
    <Space
      direction="vertical"
      size={0}
      style={{ marginBottom: 50 }}
      className="full-width-space"
    >
      <Skeleton
        loading={loading}
        active
        style={{ minHeight: 200, minWidth: 200 }}
      >
        <OverheadDataTable />
      </Skeleton>
    </Space>
  );
};
